import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { buildHoumaoAccountUrl } from '../lib/houmao-account-navigation';
import PaymentMethodSelector from '../components/payments/PaymentMethodSelector';
import {
  defaultPaymentBrand,
  detectPaymentEnvironment,
  getPaymentMethodsWithFallback,
  selectAvailablePaymentBrand,
  type PaymentBrand,
  type PaymentMethod,
} from '../lib/payment-methods';

export default function PaymentPage() {
  const location = useLocation();
  const [methods, setMethods] = useState<PaymentMethod[]>([]);
  const [loading, setLoading] = useState(true);
  const [brand, setBrand] = useState<PaymentBrand>(() => (
    defaultPaymentBrand(detectPaymentEnvironment())
  ));
  useEffect(() => {
    let cancelled = false;
    void getPaymentMethodsWithFallback()
      .then((items) => {
        if (cancelled) return;
        setMethods(items);
        setBrand((current) => selectAvailablePaymentBrand(items, current) ?? current);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);
  const availableBrand = selectAvailablePaymentBrand(methods, brand);
  const paymentParams = new URLSearchParams(location.search);
  if (availableBrand) paymentParams.set('payment_brand', availableBrand);
  const paymentQuery = paymentParams.toString();
  return (
    <div className="mx-auto max-w-xl space-y-6 py-8">
      <div>
        <p className="text-sm font-semibold uppercase tracking-widest text-stone-500">PAYMENT</p>
        <h1 className="mt-2 text-3xl font-bold text-stone-950">选择支付内容</h1>
        <p className="mt-3 text-sm leading-6 text-stone-600">
          猴毛支持微信支付和支付宝。请先选择要购买的会员或积分包，再确认支付方式。
        </p>
      </div>
      <PaymentMethodSelector methods={methods} value={brand} onChange={setBrand} loading={loading} />
      <div className="grid gap-3 sm:grid-cols-2">
        <a className="rounded-2xl border border-stone-200 bg-white p-5 font-semibold text-stone-950 hover:border-stone-500" href={buildHoumaoAccountUrl('/subscriptions', paymentQuery)}>
          购买或续订专家会员
        </a>
        <a className="rounded-2xl border border-stone-200 bg-white p-5 font-semibold text-stone-950 hover:border-stone-500" href={buildHoumaoAccountUrl('/credits', paymentQuery)}>
          购买积分包
        </a>
      </div>
    </div>
  );
}
